import { createApp } from 'vue'
import App from './App.vue'
import './assets/skin/variable/index.css'
import './assets/skin/style/index.css'
import './assets/inconfont/iconfont.css'
import 'element-plus/dist/index.css'

import router from "./router/index.js"
import store from "./store/index.js"

//组成svg图标
import zlIcon from '@/components/base/zl-icon.vue'


createApp(App).use(router).use(store).component('zl-icon',zlIcon).mount('#app')

